import store from '@/store';
import { promoCodeRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import { SET_PROMO_CODE_RESPONSE, SET_PROMO_CODE_STATUS } from '@/lib/constants/mutations';
import callApiPromo from '@/lib/helpers/call-api-promo';

const getPayload = () => {
    const { appId } = store.state;
    const { values } = store.state.formData;
    const promoCode = getValueByFieldName(values, FIELD_NAMES.promoCodeInput);

    return {
        "PromoCode": promoCode,

    };
};

export default {
    async validatePromoCode(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApiPromo({
            callbacks,
            form,
            formElement: currentStep,
            apiCallPromo: promoCodeRepository.validatePromoCode,
            payload: getPayload(),
        });

        const promoCodeResponse = response['O_RESPONSE'];
        if (promoCodeResponse) {
            store.commit(SET_PROMO_CODE_RESPONSE, { promoCodeResponse });
        }
        const promoCodeStatus = response['O_STATUS'];
        if (promoCodeStatus) {
            store.commit(SET_PROMO_CODE_STATUS, { promoCodeStatus });
        }

    }
};